 export class BubblesModule {
	constructor() {
        this.initBubles('[data-bubble]', '.bubble-content', 30, 5);
    }

    private initBubles = (bubbles, wrapperParentElement, max, min) => {
        let bubbleDiv: NodeListOf<HTMLElement> = document.querySelectorAll(bubbles);

        let wrapperParent: HTMLElement = document.querySelector(wrapperParentElement);
        let elemCount = bubbleDiv.length;
        let randomElemArray = [];
        let secondBubbleSection = wrapperParent.offsetHeight / 1.2;
        let randomSpeed = function () {
            var randomWholeNumer = Math.floor((Math.random() * 8) + 1);
            var randomDecimalNumber = randomWholeNumer / 10;
            return randomDecimalNumber;
        };
    
    
        let randomLeftPos = function () {
            var randomLeftPosValue = Math.floor(Math.random() * 100);
            return randomLeftPosValue;
        };
    
        let sizeGenerator = function () {
            let minBubbleSize = max;
            let maxBubbleSize = min;
            let size = Math.floor(Math.random() * minBubbleSize) + maxBubbleSize;
            return size;
        };
    
        let randomTopPos = function () {
            var randomTopPosPosValue = Math.floor(Math.random() * wrapperParent.offsetHeight);
            return randomTopPosPosValue;
        };
    
        for (let i = 0; i < elemCount; i++) {
            randomElemArray.push(randomSpeed());
        }

        for (let i = 0; i < bubbleDiv.length; i++) {
            let bubbleChildren = bubbleDiv[i].children;

            for (let i = 0; i < bubbleChildren.length; i++) {
                let bubbleSize = sizeGenerator();

                let elem: HTMLElement = <HTMLElement>bubbleChildren[i];
                elem.style.top = randomTopPos() + 'px';
                elem.style.left = randomLeftPos() + '%';
                elem.style.width = bubbleSize + 'px';
                elem.style.height = bubbleSize + 'px';
            }

            if (i >= (elemCount / 2)) {
                bubbleDiv[i].style.top = secondBubbleSection + 'px';
            } else {
                bubbleDiv[i].style.top = 0 + 'px';
            }
        }

        window.addEventListener("scroll", (e) => {

            let scrolled = window.scrollY;

            var scollBottom = scrolled + window.innerHeight;
            var footerTop = wrapperParent.offsetTop;
            var topCalc = scollBottom - footerTop;

            

            if (scollBottom > footerTop) {
                for (let i = 0; i < bubbleDiv.length; i++) {
                    if (i >= (elemCount / 2)) {
                        bubbleDiv[i].style.top = secondBubbleSection - (topCalc * randomElemArray[i]) + 'px';
                    } else {
                        bubbleDiv[i].style.top = 0 - (topCalc * randomElemArray[i]) + 'px';
                    }
                }
            }
         });
    }
}